'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
require('../../extends-733dd656.js');
require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
var styles_breakpoints = require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../NuDSProvider/NuDSProvider.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
var components_Typography_Typography = require('../Typography/Typography.js');
require('../../utils/ref/refType.js');
require('../../withIntlAriaAttrs-d3af74a8.js');
var components_Button_DeprecatedButton = require('../Button/DeprecatedButton.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    max-width: 420px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var fadeIn = styled.keyframes(["0%{opacity:0;bottom:0;}75%{opacity:1;}"]);
var Container = styled__default['default'].div.withConfig({
  displayName: "Container",
  componentId: "sc-1ir0ugl-0"
})(["display:flex;align-items:center;border-radius:4px;padding:1rem;width:100%;max-width:calc(100% - 3rem);background-color:", ";z-index:99;position:fixed;left:auto;right:1.5rem;bottom:1.5rem;animation:0.3s ", " ease-in-out;", ";"], styles_themeUtils.nuDSColor('black', 'light'), fadeIn, styles_breakpoints.tablet768(_templateObject()));
Container.displayName = 'Container';
var Content = styled__default['default'].div.withConfig({
  displayName: "Container__Content",
  componentId: "sc-1ir0ugl-1"
})(["flex:1;display:flex;align-items:center;"]);
Content.displayName = 'Content';
var Action = styled__default['default'].div.withConfig({
  displayName: "Container__Action",
  componentId: "sc-1ir0ugl-2"
})(["padding-left:1.5rem;"]);
Action.displayName = 'Action';

function Snackbar(_ref) {
  var actionText = _ref.actionText,
      children = _ref.children,
      visible = _ref.visible,
      onActionClick = _ref.onActionClick;

  if (!visible) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(Container, {
    role: "alert"
  }, /*#__PURE__*/React__default['default'].createElement(Content, null, /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], {
    color: "white.default",
    variant: "text2"
  }, children)), /*#__PURE__*/React__default['default'].createElement(Action, null, /*#__PURE__*/React__default['default'].createElement(components_Button_DeprecatedButton['default'], {
    onClick: onActionClick,
    typographyVariant: "text2"
  }, actionText)));
}

Snackbar.defaultProps = {
  actionText: 'Close',
  children: undefined,
  onActionClick: undefined,
  visible: false
};
Snackbar.propTypes = {
  actionText: index.propTypes.node,
  children: index.propTypes.node,
  onActionClick: index.propTypes.func,
  visible: index.propTypes.bool
};

exports.default = Snackbar;
//# sourceMappingURL=Snackbar.js.map
